import {CANCEL_ORDER} from './CancelOrder';
import {UPDATE_ORDER_COMMENT} from './UpdateOrderComment';

const Mutations = {
  CANCEL_ORDER,
  UPDATE_ORDER_COMMENT,
};

export {Mutations};
